import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a70e8a95f6f0fa1d3ab9dd976787ef530b from "./generated-01e3aea5-32f7-4447-a10a-d0fbed114394.json";

import a148eb7111f4d667e6af6313128fd0044b from "./generated-9b304083-a113-4216-a35d-4b3663d9d057.json";

import aa1ea071ec94165b89667d2f0055f7a1ab from "./generated-da7e30ca-ee7e-4f09-9c4d-087eb244672c.json";

import adc203d49931ccbd1fa0ceaa3eccce19cb from "./generated-73f54bc1-f571-4a7b-8672-c0e6b9a1f4ec.json";

import aab07b44fc66eb666d92753c0f9c0fdf1b from "./generated-d0baeea1-6670-4008-846d-4a0c39c22cc5.json";

import a5aae60e40ca284cc26203959ab87f1aab from "./generated-7f210ac0-6624-49d1-80f0-6cd51fc7ffab.json";

import a83b5e84d87bc7a9957bb73df6279ac1db from "./generated-76af7c97-0aea-462b-af6c-fbb571201879.json";

import a9b89720f14dd05dc489940ee4fbeaa3eb from "./generated-2a12f392-8f86-43a5-857d-d74d99917448.json";

import a809f923b75fa000294bf816834ba76f1b from "./generated-63a4546e-8418-4ac9-b8b4-36b5dab634b4.json";

import a50fc1e85ff5514fc94853837983bc89eb from "./generated-0ca9bc93-7b9a-49bd-a721-337a9e0ddf03.json";

import a03a5d8c19e06e48a22620f98139e7f24b from "./generated-62053cd4-089b-41e3-b3da-90365d6e3209.json";

import a022e8cf72334eaeea97e6f17ee645815b from "./generated-93704039-ca60-485e-80c7-fa3160b31d96.json";

import a14f3475392905cb9639eb032bfa05260b from "./generated-98afd17d-d065-488a-b4b2-ae77e153f87e.json";

import a5dc04a4189a1849e29028a719038eae3b from "./generated-54c10793-2c6c-44f2-b1cb-2dde447a5c21.json";

import a5a286317d19fc5972f3f0ee79cec84e1b from "./generated-3336c62f-5bbc-4b22-9a6b-2d553983897c.json";

import ac39923ba3db5e31edd93e0b6c55c2b32b from "./generated-bf499b2f-b771-4a11-9e6a-d81edec412fc.json";

import af52c5a5b9a11ebd93bc015bfd732cdb7b from "./generated-0ee04fcd-6d8f-4fc2-88e1-696c151005d1.json";

import a450f4a9c8d93b97ae6256502557d5d22b from "./generated-3d3baf3e-5c03-4bd4-906b-840354238d22.json";

import a751d5943ec8d079f265b9dd09e782070b from "./generated-e7250668-2825-4156-867d-f0e1c7b1e4cd.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a70e8a95f6f0fa1d3ab9dd976787ef530b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a148eb7111f4d667e6af6313128fd0044b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(aa1ea071ec94165b89667d2f0055f7a1ab);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(adc203d49931ccbd1fa0ceaa3eccce19cb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(aab07b44fc66eb666d92753c0f9c0fdf1b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a5aae60e40ca284cc26203959ab87f1aab);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a83b5e84d87bc7a9957bb73df6279ac1db);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a9b89720f14dd05dc489940ee4fbeaa3eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a809f923b75fa000294bf816834ba76f1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a50fc1e85ff5514fc94853837983bc89eb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a03a5d8c19e06e48a22620f98139e7f24b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a022e8cf72334eaeea97e6f17ee645815b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a14f3475392905cb9639eb032bfa05260b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a5dc04a4189a1849e29028a719038eae3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a5a286317d19fc5972f3f0ee79cec84e1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ac39923ba3db5e31edd93e0b6c55c2b32b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(af52c5a5b9a11ebd93bc015bfd732cdb7b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a450f4a9c8d93b97ae6256502557d5d22b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a751d5943ec8d079f265b9dd09e782070b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(af52c5a5b9a11ebd93bc015bfd732cdb7b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */